import React, { Component, Fragment, useState, useContext } from 'react';
import MetaTags from "react-meta-tags";
import Header from '../layouts/Header';
import Breadcrumb from '../layouts/Breadcrumb';
import Footer from '../layouts/Footer';
import Content from '../sections/finance/Content';
import Cookies from 'js-cookie';

import { AppContext } from "../../AppContext"; // adjust path if needed
import * as Yup from "yup";
import useLocalStorage from 'use-local-storage';
import { handleLogin, handleRegister } from '../../api';
import { useHistory } from 'react-router-dom';

const pagelocation = 'Finance';


const Finance = () => {

    return (
        <Fragment>
            <MetaTags>
                <title>Heritage Hub Federal Credit Union - React Template | {pagelocation}</title>
                <meta name="description" content="#" />
            </MetaTags>
            <Header />
            <div className="overlapsec" />
            <Breadcrumb breadcrumb={{ pagename: pagelocation }} />
            <AuthContent />
            <Footer />
        </Fragment>
    );
};

export default Finance;


export const AuthContent = () => {
    const navigate = useHistory()
    const { appState } = useContext(AppContext);

    const {
        login = {
            loginTitle: "Sign In to Your Account",
            registerTitle: "Create a New Account",

            emailLabel: "Email Address",
            passwordLabel: "Password",
            confirmPasswordLabel: "Confirm Password",
            nameLabel: "Full Name",

            loginButton: "Login",
            registerButton: "Register",

            noAccountText: "Don't have an account?",
            registerNowText: "Register Now",

            haveAccountText: "Already registered?",
            loginNowText: "Login Here",

            rememberMeLabel: "Remember Me",
            forgotPasswordText: "Forgot Password?",

            successLoginMessage: "Login Successful!",
            successRegisterMessage: "Registration Successful!",
            errorLoginMessage: "Invalid email or password",
            errorRegisterMessage: "Please check your information and try again"
        }

    } = appState;

    const [authMode, setAuthMode] = useState("login");
    const [loginData, setLoginData] = useState({
        email: "",
        password: "",
    });
    const [registerData, setRegisterData] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
    });
    const [errors, setErrors] = useState({});

    const loginSchema = Yup.object().shape({
        email: Yup.string().email("Invalid email").required("Email is required"),
        password: Yup.string().required("Password is required"),
    });

    const registerSchema = Yup.object().shape({  //todo
        name: Yup.string().required("Name is required"),
        email: Yup.string().email("Invalid email").required("Email is required"),
        password: Yup.string().min(6, "Password must be at least 6 characters").required("Password is required"),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref("password"), null], "Passwords must match")
            .required("Confirm Password is required"),
    });
    const [myStore, setMyStore] = useLocalStorage("name", {});

    const signIn = async ({
        email,
        password
    }) => {
        return await handleLogin({
            email, password
        }).then(res => {
            return res
        })
    }

    const handleLoginChange = async (e) => {
        setLoginData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));

        try {

        } catch (error) {
            const message = error.message || "Something went wrong";
            console.error(message)
        }
    };

    const handleRegisterChange = (e) => {
        setRegisterData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        try {
            await loginSchema.validate(loginData);
            console.log("Login Successful:", loginData);
            setErrors({});
            const res = await signIn(loginData)
            if (res?.token) {
                const myInfo = { ...res };

                // Store as cookie (stringified)
                Cookies.set('myInfo', JSON.stringify(myInfo), { expires: 7 }); // 7 days

                // Optional: Save other info in localStorage
                setMyStore({ ...myStore, myInfo: res });

                setTimeout(() => {
                    alert("Login successful");
                    navigate.push('/');
                }, 300);
            } else {
                alert(res?.message || "Login failed. Please verify your username and password and try again.");
            }
            // TODO: Send login request
        } catch (validationErrors) {
            const newErrors = {};
            validationErrors.inner.forEach((error) => {
                newErrors[error.path] = error.message;
            });
            setErrors(newErrors);
        }
    };
    const [loading, setLoading] = useState(false)
    const handleRegisterSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            // Validate the data (this will throw if invalid)
            await registerSchema.validate(registerData, { abortEarly: false });

            // Submit registration
            delete registerData?.confirmPassword
            await handleRegister({
                ...registerData,
                fullName: registerData?.name
            })

            // alert("Form submitted successfully!");
            setErrors({});
            setAuthMode("login");
        } catch (validationErrors) {
            if (validationErrors.inner) {
                const newErrors = {};
                validationErrors.inner.forEach((error) => {
                    newErrors[error.path] = error.message;
                });
                setErrors(newErrors);
            } else {
                console.error("Unexpected error:", validationErrors);
                alert("Something went wrong. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    // const handleRegisterSubmit = async (e) => {
    //     e.preventDefault();
    //     try {
    //         await registerSchema.validate(registerData, { abortEarly: false })
    //         console.log("Register Successful:", registerData);
    //         setErrors({});
    //         // TODO: Send register request
    //     } catch (validationErrors) {
    //         const newErrors = {};
    //         validationErrors.inner.forEach((error) => {
    //             newErrors[error.path] = error.message;
    //         });
    //         setErrors(newErrors);
    //     }
    // };

    return (
        <section className="section-padding-bottom user-info-details">
            <div className="container">
                <div className="row">
                    <div className="offset-lg-3 col-lg-6">
                        <div className="user-info-tabs">
                            <div className="step-app" style={{ padding: "30px", background: "white", borderRadius: "8px" }}>
                                {authMode === "login" ? (
                                    <form onSubmit={handleLoginSubmit}>
                                        <h2>{login?.loginTitle || "Login"}</h2>

                                        <div className="form-group">
                                            <label>{login?.emailLabel || "Email"}</label>
                                            <input
                                                type="email"
                                                name="email"
                                                value={loginData.email}
                                                onChange={handleLoginChange}
                                                className="form-control"
                                                required
                                            />
                                            {errors.email && <small className="text-danger">{errors.email}</small>}
                                        </div>

                                        <div className="form-group">
                                            <label>{login?.passwordLabel || "Password"}</label>
                                            <input
                                                type="password"
                                                name="password"
                                                value={loginData.password}
                                                onChange={handleLoginChange}
                                                className="form-control"
                                                required
                                            />
                                            {errors.password && <small className="text-danger">{errors.password}</small>}
                                        </div>

                                        <button type="submit" className="btn btn-primary w-100 mt-3">
                                            {login?.loginButton || "Login"}
                                        </button>

                                        <p className="text-center mt-3">
                                            {login?.noAccountText || "Don't have an account?"}{" "}
                                            <button
                                                type="button"
                                                className="btn btn-link"
                                                onClick={() => {
                                                    setErrors({});
                                                    setAuthMode("register");
                                                }}
                                            >
                                                {login?.registerNowText || "Register"}
                                            </button>
                                        </p>
                                    </form>
                                ) : (
                                    <form onSubmit={handleRegisterSubmit}>
                                        <h2>{login?.registerTitle || "Register"}</h2>

                                        <div className="form-group">
                                            <label>{login?.nameLabel || "Name"}</label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={registerData.name}
                                                onChange={handleRegisterChange}
                                                className="form-control"
                                                required
                                            />
                                            {errors.name && <small className="text-danger">{errors.name}</small>}
                                        </div>

                                        <div className="form-group">
                                            <label>{login?.emailLabel || "Email"}</label>
                                            <input
                                                type="email"
                                                name="email"
                                                value={registerData.email}
                                                onChange={handleRegisterChange}
                                                className="form-control"
                                                required
                                            />
                                            {errors.email && <small className="text-danger">{errors.email}</small>}
                                        </div>

                                        <div className="form-group">
                                            <label>{login?.passwordLabel || "Password"}</label>
                                            <input
                                                type="password"
                                                name="password"
                                                value={registerData.password}
                                                onChange={handleRegisterChange}
                                                className="form-control"
                                                required
                                            />
                                            {errors.password && <small className="text-danger">{errors.password}</small>}
                                        </div>

                                        <div className="form-group">
                                            <label>{login?.confirmPasswordLabel || "Confirm Password"}</label>
                                            <input
                                                type="password"
                                                name="confirmPassword"
                                                value={registerData.confirmPassword}
                                                onChange={handleRegisterChange}
                                                className="form-control"
                                                required
                                            />
                                            {errors.confirmPassword && <small className="text-danger">{errors.confirmPassword}</small>}
                                        </div>

                                        <button type="submit" className="btn btn-success w-100 mt-3">
                                            {login?.registerButton || "Register"}
                                        </button>

                                        <p className="text-center mt-3">
                                            {login?.haveAccountText || "Already have an account?"}{" "}
                                            <button
                                                type="button"
                                                className="btn btn-link"
                                                onClick={() => {
                                                    setErrors({});
                                                    setAuthMode("login");
                                                }}
                                            >
                                                {login?.loginNowText || "Login"}
                                            </button>
                                        </p>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

